import { styled } from '@/styled-system/jsx';

export const StyledHdpLegalInfo = styled('div', {
  base: {},
});

export const StyledHdpLegalInfoTextWrapper = styled('div', {
  base: {
    display: 'inline-block',
  },
});
